module.exports = __webpack_public_path__ + "media/src/images/logo-circle-8e4ab055371f886df7c8b330f07c6c70.png";